import React, { useContext } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { OutlinedButton } from "../../../button/Buttons.js";
import "../../../button/EditButton.js";
import "../../../modal/BulkModalContent.js";
import "../../../modal/BulkModalProvider.js";
import "@mui/material";
import "../../../modal/ModalButtons.js";
import "../../../modal/Modal.style.js";
import "../../../error/ErrorAccordion.js";
import "../../../error/ErrorDetails.js";
import "../../../error/localize.js";
import "../../../error/ErrorModal.js";
import "../../../error/GlobalServerErrorMessage.js";
import "../../../icons/Icon.js";
import "../../../icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { ModalContext } from "../../../modal/types.js";
import { ActionConfirmationModal } from "../../../modal/ActionConfirmationModal.js";
const useStyles = makeStyles()((theme) => ({
  muiGridActionWithConfirmationButtonCell: {
    minWidth: "80px",
    height: "32px",
    borderRadius: theme.custom.defaultBorderRadius * 2
  }
}));
function renderMuiGridActionWithConfirmationButtonCell(params) {
  const { classes } = useStyles();
  const {
    label,
    confirmAction,
    confirmActionPayload,
    modalTitle,
    description,
    descriptionValues,
    cancelButtonLabel,
    disabled,
    confirmButtonLabel
  } = params.value;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { openModal, closeModal } = useContext(ModalContext);
  function handleConfirm() {
    dispatch(confirmAction.request(confirmActionPayload));
    closeModal();
  }
  function handleClick() {
    openModal({
      body: /* @__PURE__ */ React.createElement(
        ActionConfirmationModal,
        {
          title: modalTitle,
          contentDescription: descriptionValues ? formatMessage(description, descriptionValues) : description,
          handleConfirm,
          handleCancel: closeModal,
          cancelButtonLabel,
          confirmButtonLabel
        }
      ),
      styleParams: { maxWidth: "xs" }
    });
  }
  return /* @__PURE__ */ React.createElement(
    OutlinedButton,
    {
      className: classes.muiGridActionWithConfirmationButtonCell,
      label,
      onClick: handleClick,
      disabled
    }
  );
}
export {
  renderMuiGridActionWithConfirmationButtonCell
};
//# sourceMappingURL=ActionWithConfirmationButton.js.map
